import { BottomSheetModalMethods } from '@gorhom/bottom-sheet/lib/typescript/types'
import React, { RefObject, createContext, useContext } from 'react'

const TextEditorModalContext = createContext<RefObject<BottomSheetModalMethods> | null>(null)

type TextEditorModalProviderProps = {
  textEditorModalRef: RefObject<BottomSheetModalMethods>
  children: React.ReactNode
}

const TextEditorModalProvider = ({
  textEditorModalRef,
  children,
}: TextEditorModalProviderProps) => {
  return (
    <TextEditorModalContext.Provider value={textEditorModalRef}>
      {children}
    </TextEditorModalContext.Provider>
  )
}

const useTextEditorModal = () => {
  return useContext(TextEditorModalContext)
}

export { TextEditorModalProvider, useTextEditorModal }
